import getInitials from "../../../../utils/getInitials";
import { useContext } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";

export default function Approver({
  item,
  access,
  index,
  handleDelete,
  type,
}: any) {
  const { auth } = useContext(AuthContext);
  return (
    <div className="relative rounded-lg  group hover:bg-gray-100">
      <div className="flex">
        <div className="flex items-center" key={index}>
          <div className="mr-2">{getInitials(item?.name)}</div>
          <div className="text-gray-600">{item?.name}</div>
        </div>
      </div>

      {access.includes(auth?.accessLevel) && (
        <button
          onClick={() => handleDelete({ item, type })}
          className="absolute bottom-1 -right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 text-red-500 hover:text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7L5 21M5 7l14 14"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
